import LevitPopup from '../utils/levit-popup';
import FormIframe, { bindFormEmbedWarmup } from '../utils/form-iframe';

class EndowOpportunities {
	constructor(element) {
		this.el = element;
		this.cards = [...element.querySelectorAll('.endow-card')];

		this.popupEl = document.getElementById('levit-popup-endow');
		this.popupTitle = this.popupEl?.querySelector('[data-endow-popup-title]');
		this.popupDescription = this.popupEl?.querySelector('[data-endow-popup-description]');
		this.popupCost = this.popupEl?.querySelector('[data-endow-popup-cost]');
		this.popupFormWrap = this.popupEl?.querySelector('[data-endow-popup-form]');
		this.popupMedia = this.popupEl?.querySelector('[data-endow-popup-media]');
		this.popupImage = this.popupEl?.querySelector('[data-endow-popup-image]');

		this.formIframe = this.popupFormWrap
			? new FormIframe(this.popupFormWrap, {
				className: 'endow-popup__form-iframe',
				title: 'Donation form',
			})
			: null;

		this.popup = this.popupEl
			? new LevitPopup(this.popupEl, {
				bodyClass: 'endow-popup-open',
				onClose: () => this.formIframe?.teardown(),
			})
			: null;

		this.initCards();
	}

	static decodeBase64Utf8(value) {
		try {
			const binary = atob(value);
			const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
			return new TextDecoder().decode(bytes);
		} catch {
			return '';
		}
	}

	buildRecord(card) {
		const longHtml = card.dataset.longHtml ? EndowOpportunities.decodeBase64Utf8(card.dataset.longHtml) : '';

		return {
			title: card.dataset.title || '',
			cost: card.dataset.cost || '',
			short: card.dataset.short || '',
			longHtml,
			formSrc: card.dataset.formSrc || '',
			image: card.dataset.image || '',
		};
	}

	initCards() {
		this.cards.forEach((card) => {
			if (card.classList.contains('is-reserved')) return;

			bindFormEmbedWarmup(card, card.dataset.formSrc || '', this.formIframe, () => !!this.popup?.isOpen());
			card.addEventListener('click', () => this.openPopup(card));
			card.addEventListener('keydown', (event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					this.openPopup(card);
				}
			});
		});
	}

	openPopup(card) {
		if (!this.popup) return;

		const record = this.buildRecord(card);

		if (this.popupTitle) {
			this.popupTitle.textContent = record.title;
		}

		if (this.popupDescription) {
			if (record.longHtml) {
				this.popupDescription.innerHTML = record.longHtml;
			} else if (record.short) {
				this.popupDescription.textContent = record.short;
			} else {
				this.popupDescription.textContent = '';
			}
		}

		if (this.popupCost) {
			this.popupCost.textContent = record.cost;
			this.popupCost.hidden = !record.cost;
		}

		const hasForm = !!record.formSrc;
		const hasImage = !hasForm && !!record.image;

		this.popupEl?.classList.toggle('endow-popup--has-form', hasForm);
		this.popupEl?.classList.toggle('endow-popup--has-image', hasImage);
		this.popupEl?.classList.toggle('endow-popup--single', !hasForm && !hasImage);

		if (hasForm) {
			this.formIframe?.mount(record.formSrc);
		} else {
			this.formIframe?.teardown();
		}

		if (this.popupImage) {
			if (hasImage) {
				this.popupImage.src = record.image;
				this.popupImage.alt = record.title || '';
			} else {
				this.popupImage.removeAttribute('src');
				this.popupImage.alt = '';
			}
		}

		this.popup.open();
		requestAnimationFrame(() => this.formIframe?.resize());
	}

	closePopup() {
		this.popup?.close();
	}

	destroy() {
		this.popup?.destroy();
		this.formIframe?.teardown();
	}

	static init() {
		document.querySelectorAll('[data-component="endow-opportunities"]').forEach((element) => {
			new EndowOpportunities(element);
		});
	}
}

export default EndowOpportunities;